import { render, staticRenderFns } from "./nbbankfiles-add-or-update.vue?vue&type=template&id=7d5e792c&"
import script from "./nbbankfiles-add-or-update.vue?vue&type=script&lang=js&"
export * from "./nbbankfiles-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports